import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddDecision from './adddecision/index'
import DecisionList from './decisionlist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddDecisionProtected_ma = userIsCommitteeAdminRedir(AddDecision)
const DecisionListProtected_ma = userIsCommitteeAdminRedir(DecisionList)

const Decision = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Decision Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/decision-list`} />
            <Route path={`${match.url}/add-decision/:id?/:committee_id?`} component={AddDecisionProtected_ma} />
            <Route path={`${match.url}/decision-list/:id?`} component={DecisionListProtected_ma} />
        </Switch>
    </div>
);

export default Decision;



// WEBPACK FOOTER //
// ./app/decisiondetails/index.js